import {useEffect, useState} from 'react';
import {isOffPath} from '@utils/board';
import {TNode} from 'ghostban';

export const useOffPath = (sgf?: string, currentNode?: TNode) => {
    const [offPath, setOffPath] = useState<boolean>(false);

    useEffect(() => {
        if (!sgf || !currentNode) return;
        setOffPath(isOffPath(currentNode, sgf));
    }, [sgf, currentNode]);
    return [offPath, setOffPath];
};
